/**
 * Subscribe to a media query as React state.
 *
 * The settled design's 820px breakpoint changes STRUCTURE (the sidebar
 * becomes an off-canvas drawer, a topbar appears), not just styles — so the
 * shell needs the answer as state, not as CSS. `useSyncExternalStore` keeps
 * it tear-free, and an environment with no `matchMedia` (a bare test DOM)
 * answers `false`, which renders the desktop layout — the same thing every
 * existing test already asserts against.
 */

import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof matchMedia === "undefined") return () => {};
      const list = matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => (typeof matchMedia === "undefined" ? false : matchMedia(query).matches),
    () => false,
  );
}
